export default __webpack_public_path__ + "static/media/long jiao.1fe501e1.jpg";